import type { SendChatMessageResponse } from '../lib/responses/sendChatMessage';
import type { SendChatMessageRequest } from '../lib/payloads/sendChatMessage';
import { post } from './baseUrl';
import { ApiEndpoint } from './endpoints';

export const extractSuggestionResponse = (
  response: SendChatMessageResponse,
): string[] => {
  const suggestedResponses = response.data?.suggestedResponses;

  if (!Array.isArray(suggestedResponses)) {
    return [];
  }

  return suggestedResponses.filter(
    (suggestion): suggestion is string => typeof suggestion === 'string',
  );
};

export const sendChatMessage = async (
  request: SendChatMessageRequest,
): Promise<SendChatMessageResponse> => {
  const response = await post(ApiEndpoint.sendChatMessage, request);

  const responseData = response.data?.data as SendChatMessageResponse;
  return responseData;
};
